
















import StepperShell from './views/sale/sale-stepper.shell.vue';
import { Component, Vue } from 'vue-property-decorator';
import Logo from '@/components/AppHeader.vue';
import TopBar from '@/components/TopBar.vue';
import AppFooter from '@/components/AppFooter.vue';
import { Getter } from 'vuex-class';

@Component({
  components: {
    AppFooter,
    TopBar,
    Logo,
    StepperShell,
    CovidModal: () => import('@/components/CovidModal.vue'),
  },
})
export default class LayoutDefault extends Vue {
  @Getter('widget/amenities') amenities!: any;

  dialog = {
    show: false,
    type: 'COVID_19',
  };

  showInfo() {
    this.dialog.show = true;
  }
}
